import { SourceType } from "model";

export const getDemoModePlatform = (
  sourceType: Exclude<SourceType, "Banking" | "Other">
): string => {
  switch (sourceType) {
    case "Accounting":
      return "mqjo";
    case "Commerce":
      return "aiwb";
  }
};

export const isDemoModeValid = (
  isDemoMode: boolean,
  enabledIntegrationKeys: string[],
  currentSourceType: SourceType
): boolean => {
  if (
    !isDemoMode ||
    currentSourceType === "Banking" ||
    currentSourceType === "Other" ||
    currentSourceType === undefined
  ) {
    return true;
  } else {
    const sandboxKey = getDemoModePlatform(currentSourceType);
    return enabledIntegrationKeys.includes(sandboxKey);
  }
};
